<form name="form" *ngIf="mVisible" (ngSubmit)="send($event,f , f.form.valid, 'contactModal');" #f="ngForm" novalidate>
  <div class="modal fade" data-backdrop="static" data-keyboard="false" id="contactModal" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content zind1 boxRadius">
        <div class="modal-body">
          <button type="button" class="close videoclose" data-dismiss="modal" aria-label="Close" (click)="closeContactModal(f)">
            <!-- <span aria-hidden="true">&times;</span> -->
            <div class="float-right mr-1 mt-1" >
                <img src="assets/images/editchart-close.svg" width="20">
              </div>
          </button>
          <div class="service-modal px-5">
            <h1 class="text-center conthead font-weight-bold-calibre mt-4">HOW CAN WE SERVE YOU</h1>
            <div class="bdy-sec pt-0">
              <div>
                <p class="sb-ttl font-weight-normal-calibre pb-3">Provide your contact details, state your question, and we'll get back to you</p>
              </div>
              <div class="form-group">
                <!-- <label for="fullName">Full Name</label> -->
                <input type="text" class="form-control inputshadow" name="fullName" [(ngModel)]="userObj.fullName"  (keydown.space)="userObj.fullName ? null : $event.preventDefault()"
                  #fullName="ngModel" [ngClass]="{ 'is-invalid': f.submitted && fullName.invalid }" maxlength="60" placeholder="Full Name" required />
                <div *ngIf="f.submitted && fullName.invalid" class="invalid-feedback">
                  <div *ngIf="fullName.errors.required" class="boxcolour"><span _ngcontent-c2="" class="fa fa-exclamation-circle mr-1"
                      type="Icon"></span>Full Name is required</div>
                </div>
              </div>
              <!-- <div class="form-group">
                <input type="text" class="form-control inputshadow fullNamePlace" name="email" [(ngModel)]="userObj.emailId" #email="ngModel"
                  [ngClass]="{ 'is-invalid': f.submitted && email.invalid }" placeholder="EMAIL ADDRESS" required email />
                <div *ngIf="f.submitted && email.invalid" class="invalid-feedback">
                  <div *ngIf="email.errors.required" class="boxcolour"><span _ngcontent-c2="" class="fa fa-exclamation-circle mr-1"
                      type="Icon"></span>Email is required</div>
                  <div *ngIf="email.errors.email" class="boxcolour"><span _ngcontent-c2="" class="fa fa-exclamation-circle mr-1"
                      type="Icon"></span>Please enter a valid email</div>
                </div>
              </div> -->
              <div class="form-group">
                  <input type="text" class="form-control inputshadow" name="email" maxlength="60" [(ngModel)]="userObj.emailId" (keydown.space)="userObj.emailId ? null : $event.preventDefault()" #email="ngModel" [ngClass]="{ 'is-invalid': f.submitted && email.invalid }"
                    required email pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)\.*$"
                    placeholder="Email Address"/>
                  <div *ngIf="f.submitted && email.invalid" class="invalid-feedback">
                    <div class="boxcolour" *ngIf="email.errors.required">
                          <span class="fa fa-exclamation-circle mr-1"
                          type="Icon"></span>Email is required</div>
                  </div>
                  <div [hidden]="email.valid || email.pristine || !email.errors.pattern" class="">
                    <div class="boxcolour alertMsg">
                          <span class="fa fa-exclamation-circle mr-1"
                          type="Icon"></span>Please enter a valid email</div>
                  </div>
              </div>
              <div class="form-group ">
                <!-- <label for="contactQues">What's your burning question!</label> -->
                <textarea type="text" class="form-control inputshadow removeResize" name="contactQues" [(ngModel)]="userObj.contactQues" (keydown.space)="userObj.contactQues ? null : $event.preventDefault()"
                  #contactQues="ngModel" [ngClass]="{ 'is-invalid': f.submitted && contactQues.invalid }" maxlength="150" placeholder="What's Your Burning Question?" required ></textarea>
                <div *ngIf="f.submitted && contactQues.invalid" class="invalid-feedback">
                  <div *ngIf="contactQues.errors.required" class="boxcolour"><span _ngcontent-c2="" class="fa fa-exclamation-circle mr-1"
                      type="Icon"></span>Please enter a value</div>
                </div>
              </div>
              <div class="form-group float-label-control text-center mb-1 pt-2">
                <button class="btn mr-2 ml-2 col-12 font-weight-bold-calibre contbtn" data-backdrop="false">SEND</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

<div class="modal fade" data-backdrop="static" data-keyboard="false" id="helpModel" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content zind1 brdRadius">
        <div class="modal-body">
          <button type="button" class="close videoclose" data-dismiss="modal" aria-label="Close" (click)="closeResetModal()">
            <div class="float-right mr-1 mt-1" >
              <img src="assets/images/editchart-close.svg" width="20">
            </div>
          </button>
          <div class="service-modal">
            <div class="bdy-sec">
              <div>
                <p class="mt-4 sb-ttl resettxt text-center">Thank you! Your message has been sent. A member of our team will be in touch soon!
                <!-- <font class="text-center semi-bold">{{enteredEmail}}</font></p> -->
              </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ngx-spinner></ngx-spinner>
<!-- Modal -->
<div class="backdrop" [ngStyle]="{'display':display}"></div>
<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':display}">
  <div class="modal-dialog" role="document">
    <div class="modal-content m-auto blockbg boxclr text-center">
      <div class="modal-body">
        <!-- <div class="mt-5"> -->
        <div class="">
          <img src="assets/images/loading.gif" />
          <p class="text-center tipmes font15">Please wait for a few seconds...
          </p>
        </div>
        <!-- </div> -->
      </div>
    </div>
    <!-- /.modal-content -->
  </div>
  <!-- /.modal-dialog -->
</div>
<!-- /.modal !-->